import * as React from 'react';
import { LayoutBlock, LayoutBlockProps } from './layout-block';

interface LabelProps extends LayoutBlockProps {
	color?: string;
	shadow?: boolean;
	shadowStyle?: string;
}
const Label: React.StatelessComponent<LabelProps> = props => {
	var config = { ...props };
	delete config.color;
	delete config.shadow;
	delete config.shadowStyle;
	return (
		<LayoutBlock {...config}>
			<span style={{ color: props.color, textShadow: props.shadow ? props.shadowStyle : null }}>{props.children}</span>
		</LayoutBlock>
	);
};

Label.defaultProps = {
	shadowStyle: '0 0 1px black',
};

export default Label;
